export function capitalizeWords(string) {
  if (typeof string !== "string") return "";
  return string
    .split(/ /g)
    .map(word => `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`)
    .join(" ");
}
